import { PartnerEvent } from "src/types/type";

export const getPCodeEvent = (pcode: string, eventList: PartnerEvent[]) : PartnerEvent => {
  return eventList.filter((ev) => ev.pCodeList?.includes(pcode))[0];
};